export const AGE_GROUPS = [
  {value: 'BABY', labelKey: 'ageGroup_baby', ageRange: '0 - 3'},
  {value: 'CHILD', labelKey: 'ageGroup_child', ageRange: '3 - 6'},
  {
    value: 'SCHOOLCHILD',
    labelKey: 'ageGroup_schoolchild',
    ageRange: '6 - 13'
  },
  {value: 'TEEN', labelKey: 'ageGroup_teen', ageRange: '13 - 20'},
  {value: 'ADULT20', labelKey: 'ageGroup_adult20', ageRange: '20 - 35'},
  {value: 'ADULT35', labelKey: 'ageGroup_adult35', ageRange: '35 - 60'},
  {value: 'SENIOR', labelKey: 'ageGroup_senior', ageRange: '60+'},
  {value: 'ALL', labelKey: 'ageGroup_all'}
];

export const genders = [
  {value: 'MALE', label: 'Male'},
  {value: 'FEMALE', label: 'Female'},
  {value: 'OTHER', label: 'Other'},
  {value: 'NA', label: 'NA'}
];

export const daysOfWeek = {
  0: 'weekdaySunday_short',
  1: 'weekdayMonday_short',
  2: 'weekdayTuesday_short',
  3: 'weekdayWednesday_short',
  4: 'weekdayThursday_short',
  5: 'weekdayFriday_short',
  6: 'weekdaySaturday_short'
};

export const daysOfWeekLong = {
  1: 'weekdaySunday',
  2: 'weekdayMonday',
  3: 'weekdayTuesday',
  4: 'weekdayWednesday',
  5: 'weekdayThursday',
  6: 'weekdayFriday',
  7: 'weekdaySaturday'
};

export const DEFAULT_LONGITUDE = 6.953101;
export const DEFAULT_LATITUDE = 50.935173;

export enum GendersEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
  NA = 'NA'
}

export enum NetworkStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum LogLevel {
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR'
}

export enum CompanyRole {
  EMPLOYEE_1 = 'EMPLOYEE_1',
  HEALTH_MANAGER = 'HEALTH_MANAGER',
  TRAINER = 'TRAINER',
  NONE = 'NONE'
}

export enum CompanyRoleAll {
  EMPLOYEE_1 = 'EMPLOYEE_1',
  EMPLOYEE_2 = 'EMPLOYEE_2',
  EMPLOYEE_3 = 'EMPLOYEE_3',
  EMPLOYEE_4 = 'EMPLOYEE_4',
  EMPLOYEE_5 = 'EMPLOYEE_5',
  HEALTH_MANAGER = 'HEALTH_MANAGER',
  SPOUSE = 'SPOUSE',
  TRAINER = 'TRAINER'
}

export const CITY_COORDINATES = {
  berlin: {lat: 52.52, lng: 13.405, label: 'Berlin, Deutschland'},
  hamburg: {lat: 53.5511, lng: 9.9937, label: 'Hamburg, Deutschland'},
  muenchen: {lat: 48.1351, lng: 11.582, label: 'München, Deutschland'},
  koeln: {lat: 50.9375, lng: 6.9603, label: 'Köln, Deutschland'},
  frankfurt: {lat: 50.1109, lng: 8.6821, label: 'Frankfurt, Deutschland'},
  dortmund: {lat: 51.5136, lng: 7.4653, label: 'Dortmund, Deutschland'},
  nuernberg: {lat: 49.4521, lng: 11.0767, label: 'Nürnberg, Deutschland'},
  aachen: {lat: 50.7753, lng: 6.0839, label: 'Aachen, Deutschland'},
  leipzig: {lat: 51.3397, lng: 12.3731, label: 'Leipzig, Deutschland'},
  dresden: {lat: 51.0504, lng: 13.7373, label: 'Dresden, Deutschland'},
  duesseldorf: {lat: 51.2277, lng: 6.7735, label: 'Düsseldorf, Deutschland'},
  bonn: {lat: 50.7374, lng: 7.0982, label: 'Bonn, Deutschland'}
};

export const EVENTS_TAB_CUSTOM_KEYS: Record<string, string> = {
  dkh: 'resilience',
  sievert: 'resilience'
};

export const SHOULD_START_WITH_EVENT_TAGS = ['dkh', 'sievert'];
